import { render } from "./UiAddButton.vue?vue&type=template&id=523f360c"
import script from "./UiAddButton.vue?vue&type=script&lang=js"
export * from "./UiAddButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__